import { CustomerType } from '@core/enums/customer/customer-type.enum';
import { ICustomer } from '@core/interfaces/customer/customer.interface';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';

export const CUSTOMERS: IListResult<ICustomer> = {
  results: [
    {
      type: CustomerType.COMPANY,
      firstName: 'firstName',
      lastName: 'lastName',
      email: 'email@asd.hu',
      phoneNumber: '+3625478987',
      zipCode: '1111',
      city: 'city',
      country: 'HU',
      address: 'address',
      billingName: 'billingName',
      billingTaxNumber: 'billingTaxNumber',
      billingZipCode: 'billingZipCode',
      billingCity: 'billingCity',
      billingAddress: 'billingAddress',
      billingCountry: 'billingCountry',
      county: 'Pest',
      companyName: 'nincs',
      vatNumber: '12345676-2-13', // Valid
    },
    {
      type: CustomerType.COMPANY,
      email: 'email',
      phoneNumber: 'phoneNumber',
      zipCode: 'zipCode',
      city: 'city',
      country: 'Hungary',
      address: 'address',
      billingName: 'billingName',
      billingTaxNumber: 'billingTaxNumber',
      billingZipCode: 'billingZipCode',
      billingCity: 'billingCity',
      billingAddress: 'billingAddress',
      billingCountry: 'billingCountry',
      companyName: 'companyName',
    },
    {
      type: CustomerType.PERSON,
      firstName: 'firstName',
      lastName: 'lastName',
      email: 'email',
      phoneNumber: 'phoneNumber',
      zipCode: 'zipCode',
      city: 'city',
      country: 'Hungary',
      address: 'address',
      billingName: 'billingName',
      billingTaxNumber: 'billingTaxNumber',
      billingZipCode: 'billingZipCode',
      billingCity: 'billingCity',
      billingAddress: 'billingAddress',
      billingCountry: 'billingCountry',
    },
  ],
  resultsLength: 3,
};
